<template>
  <div>
    <div class="row no-gutters">
      <div class="col-xl-3 col-lg-4 order-2 order-lg-1">
        <section>
          <app-contact-detail
            :dataContact="fullContact"
            :dataCourses="courses"
            @changeData="saveData"
          ></app-contact-detail>
        </section>
      </div>
      <div class="col-12 col-xl-9 col-lg-8 order-1 order-lg-2">
        <div class="row no-gutters">
          <b-skeleton-wrapper :loading="loading">
            <div class="col-12 pl-2 pr-2">
              <b-skeleton
                width="25%"
                animation="wave"
                class="mt-4 mb-4"
              ></b-skeleton>

              <b-skeleton-table
                :rows="5"
                :columns="3"
                :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </b-skeleton-wrapper>
          <app-activity-contact-table
            v-if="loading == true"
            :getItems="contactsActivities"
            :contactId="this.$route.query.id"
            :dataContact="contact"
            @changeData="listTypeActivity"
            @changeActivity="SingleContact"
            ref="component"
          ></app-activity-contact-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppActivityContactTable from "../components/AppActivityContactTable.vue";
import AppContactDetail from "../components/AppContactDetail.vue";
import moment from "moment";
export default {
  components: { AppActivityContactTable, AppContactDetail },
  name: "DettagliContatto",

  data() {
    return {
      getpayload: null,
      contact: null,
      loading: false,
      contactsActivities: null,
      contactsCourses: null,
      courses: null,
    };
  },

  /* created() {
    this.SingleContact();
    this.listTypeActivity();
    this.listCourses();
    this.listKnown();
  }, */

  async created (){
    await this.SingleContact();
    await this.listTypeActivity();
    await this.listCourses();
    await this.listKnown();
  },

  computed: {
    listContactsActivities() {
      return this.contactsActivities;
    },

    fullContact() {
      // Activity storage is loaded by the table component <-<
      const activities = this.$store.getters["activity/activity"];
      const activityTypes = this.typeActivity;
      if (!activityTypes)
        return this.contact;
      const typeMap = {};
      for (let type of activityTypes)
        typeMap[type.activity.id] = type.activity;
      const map = {};
      for (let activityNode of activities)
        map[activityNode.activity.id] = {
          type: typeMap[activityNode.activity.activityType_Id],
          activity: activityNode.activity
        };
      const now = moment();
      const contact = this.contact;
      const contactActivities = this.contactsActivities;
      if (!contact || contact.lastDirectContact?.elapsedValue || !contactActivities)
        return contact;
      let lastDirectContact = null;
      for(let activityReference of contactActivities){
        const ref = map[activityReference.idActivity];
        if (!ref)
          continue;
        const {type, activity} = ref;
        const timestamp = activity && activityReference.eventDt && moment(activityReference.eventDt);
        if (activity && timestamp && type.isDirectContact
            && (!lastDirectContact || timestamp.isAfter(lastDirectContact.timestamp)))
          lastDirectContact = {timestamp, activity, elapsed: timestamp.from(now), elapsedValue: now.diff(timestamp)};
      }
      contact.lastDirectContact = lastDirectContact || {elapsed: 'Nessun contatto', elapsedValue: 365 * 24 * 60 * 60 * 1000}; // 1y
      return {...contact};
    }
  },

  methods: {
    async listTypeActivity() {
      try {
        await this.$store.dispatch("typeActivity/getTypeActivity").then(() => {
          this.typeActivity = this.$store.getters["typeActivity/listActivity"];
          /*  this.$refs.component.refresh(); */
          this.loading = true;
          return this.typeActivity;
        });
      } catch (e) {
        this.loading = false;
        console.error("Failed to process getActivity:", e);
        this.$bvToast.toast("Errore durante il caricamento delle attività. I dati visualizzati potrebbero non essere completi.", {
          title: "Errore caricamento dati",
          toaster: "b-toaster-bottom-right",
          solid: true,
          variant: "danger",
          appendToast: true,
        });
      }
    },

    async listCourses() {
      try {
        await this.$store.dispatch("courses/getCourses").then(() => {
          this.courses = this.$store.getters["courses/listCourses"];

          return;
        });
      } catch (e) {
        console.log("Failed to execute courses/getCourses or courses/listCourses:", e);
      }
    },

    async listKnown() {
      try {
        await this.$store.dispatch("KnownusTypes/getKnownustypes").then(() => {
          this.known = this.$store.getters["KnownusTypes/listKnownusTypes"];

          return;
        });
      } catch (e) {
        console.log("Failed to execute KnownusTypes/getKnownustypes or KnownusTypes/listKnownusTypes:", e);
      }
    },

    saveData($editCourses, $editContact) {
        console.log("saveData()");
        console.log($editCourses);
        console.log($editContact);

      const $contactsCourses = [];
      const $person = { ...$editContact.person };
      const $dataBirday = $person.birthDt;
      /* console.log($dataBirday); */
      $person.birthDt = moment.utc($dataBirday).format();
      /* console.log($person.birthDt); */

      const $id = $editContact.id;

      $editCourses.forEach((el) => {
        if (el.select == true) {
          $contactsCourses.push({
            idCourse: el.id,
          });
        }
      });

      /*     console.log($contactsCourses); */
       console.log( $person);

      var data = {
        id: $id,
        editContact: $editContact,
        editPerson: $person,
        editCourses: $contactsCourses,
        contactsActivities: $editContact.contactsActivities,
      };

      this.saveDataContact(data)
      /* this.$store.dispatch("contact/putContact", data); */
      /* this.toast(
        `Modifica effetuata`,
        `Modifica effetuata con successo`,
        "success",
        true
      ); */
    },


     async saveDataContact(data) {
      try {
        await this.$store.dispatch("contact/putContact", data).then((data) => {

          console.log(data);
          if(data == true){
              this.toast(
                `Modifica effetuata`,
                `Modifica effetuata con successo`,
                "success",
                true
              );
          } else {
              this.toast(
              `Errore salvataggio`,
              `modifica non salvata correttamente`,
              "warning",
              true
            );
          }

          return data;




        });
      } catch (e) {
        console.log({ message: "Some error putContact" });
      }
    },

    async SingleContact() {
      console.log("### SingleContact");
      try {
        await this.$store
          .dispatch("contact/getSingleContact", {
            id: this.$route.query.id,
          })
          .then(() => {
            this.contact = this.$store.getters[
              "contact/singleContact"
            ].contacts[0];
            /*  this.$refs.component.refresh(); */
            // console.log(this.contact.idKnownUsType, this.contact.editKnown);
            // console.log(this.contact.person.email);
            /* this.loading = true; */

            if (this.contact != null) {
              this.contactsActivities = this.contact.contactsActivities;
              // this.contact.editKnown = this.contact.idKnownUsType;
            }
            return this.contact;
          });
      } catch (e) {
        this.loading = false;
        console.log({ message: "Some error SingleContact" });
      }
    },

    toast(title, message, variant, append = false) {
      this.counter++;
      this.$bvToast.toast(message, {
        title: title,
        toaster: "b-toaster-bottom-right",
        solid: true,
        variant: variant,
        appendToast: append,
      });
    },
  },
};
</script>
